export const masterData = {
    imagePrice: [
        {
            id: 'RWBC0001.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '8000',
                'Extra Large': '8000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0002.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '8000',
                'Extra Large': '8000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0003.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '8000',
                'Extra Large': '8000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0004.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '8000',
                'Extra Large': '8000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0005.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '8000',
                'Extra Large': '8000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0006.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '8000',
                'Extra Large': '8000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0007.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '8000',
                'Extra Large': '8000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0008.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '8000',
                'Extra Large': '8000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0009.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '8000',
                'Extra Large': '8000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0010.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '8000',
                'Extra Large': '8000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0011.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '8000',
                'Extra Large': '8000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0012.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '8000',
                'Extra Large': '8000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0013.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '23000',
                'Extra Large': '23000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0014.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '8000',
                'Extra Large': '8000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0015.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '23000',
                'Extra Large': '23000',
                'Extra Larger': '23000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0016.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '23000',
                'Extra Large': '23000',
                'Extra Larger': '23000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0017.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '23000',
                'Extra Large': '23000',
                'Extra Larger': '23000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0018.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '8000',
                'Extra Large': '8000',
                'Extra Larger': '8000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0019.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '25000',
                'Extra Large': '25000',
                'Extra Larger': '25000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0020.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '25000',
                'Extra Large': '25000',
                'Extra Larger': '25000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0021.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '25000',
                'Extra Large': '25000',
                'Extra Larger': '25000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0022.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '25000',
                'Extra Large': '25000',
                'Extra Larger': '25000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0023.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '25000',
                'Extra Large': '25000',
                'Extra Larger': '25000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0024.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '25000',
                'Extra Large': '25000',
                'Extra Larger': '25000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0029.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '18000',
                'Extra Large': '18000',
                'Extra Larger': '18000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0030.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '18000',
                'Extra Large': '18000',
                'Extra Larger': '18000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0031.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '18000',
                'Extra Large': '18000',
                'Extra Larger': '18000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0032.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '18000',
                'Extra Large': '18000',
                'Extra Larger': '18000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0033.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '18000',
                'Extra Large': '18000',
                'Extra Larger': '18000',
                Vector: '21000'
            }
        }, {
            id: 'RWBC0035.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '0',
                'Extra Large': '0',
                'Extra Larger': '0',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0034.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '18000',
                'Extra Large': '18000',
                'Extra Larger': '18000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0036.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '8000',
                'Extra Large': '8000',
                'Extra Larger': '8000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0037.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '8000',
                'Extra Large': '8000',
                'Extra Larger': '8000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0038.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '8000',
                'Extra Large': '8000',
                'Extra Larger': '8000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0039.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '8000',
                'Extra Large': '8000',
                'Extra Larger': '8000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0040.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '8000',
                'Extra Large': '8000',
                'Extra Larger': '8000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0041.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '8000',
                'Extra Large': '8000',
                'Extra Larger': '8000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0042.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '8000',
                'Extra Large': '8000',
                'Extra Larger': '8000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0043.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '8000',
                'Extra Large': '8000',
                'Extra Larger': '8000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0044.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '8000',
                'Extra Large': '8000',
                'Extra Larger': '8000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0045.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '8000',
                'Extra Large': '8000',
                'Extra Larger': '8000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0046.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '8000',
                'Extra Large': '8000',
                'Extra Larger': '8000',
                Vector: '21000'
            }
        },
        {
            id: 'RWBC0047.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '15000',
                Large: '15000',
                'Extra Large': '15000',
                'Extra Larger': '15000',
                Vector: '21000'
            }
        }, {
            id: 'RWBC0048.JPG',
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '8000',
                'Extra Large': '8000',
                'Extra Larger': '8000',
                Vector: '21000'
            }
        }],

    categories: [
        {
            id: 0,
            name: 'Default',
            hasSubCategory: false,
            parentId: 0,
            creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 21,
            name: 'INPIX-RF',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: true,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 22,
            name: 'Inpix RF_A',
            hasSubCategory: true,
            parentId: 0,
            creativeIndianSearch: true,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 23,
            name: 'Zero-03',
            hasSubCategory: true,
            parentId: 0, creativeIndianSearch: true,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 24,
            name: 'InPix-Lite',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: true,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 25,
            name: 'Inpix Premium_A',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: true,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 26,
            name: 'Inpix Premium IP_A',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: true,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 11,
            name: 'IP-Purple',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 207,
            name: 'IP-Blue',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: true,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 208,
            name: 'IP-Arts',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: true,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 12,
            name: 'InPix-RM',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: true,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 13,
            name: 'IP Black',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: true,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000',
                SD: '5000'
            }
        },
        {
            id: 41,
            name: 'Image Source RF',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: true,
            editorialInternationalSearch: true,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 42,
            name: 'PICTURE_INDIA (Asia Images)',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 43,
            name: 'Photos India',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 44,
            name: 'Veer Images',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 45,
            name: 'South India Picture',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 46,
            name: 'Monkey Business',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 47,
            name: 'Glow Images',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 48,
            name: 'Glow Decor',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 49,
            name: 'Glow Asia',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 50,
            name: 'I Love Images',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 51,
            name: 'Built Images',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 52,
            name: 'Glow Images RF',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 53,
            name: 'Ojo Images',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 54,
            name: 'MoodBoard Plus',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 55,
            name: 'MoodBoard Budget',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 56,
            name: 'ValueClips Clip Art',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 57,
            name: 'LushPix Illustration',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 58,
            name: 'MoodBoard Value',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 59,
            name: 'MoodBoard Premium',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 60,
            name: 'Sheltered',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 61,
            name: 'EPA',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 62,
            name: 'Juice Images',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: true,
            editorialInternationalSearch: true,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 63,
            name: 'Images Bazaar Sliver',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 64,
            name: 'Images Bazaar Gold',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 65,
            name: 'Images Bazaar platinum',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 66,
            name: 'Juice Lite',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 67,
            name: 'AWL',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 68,
            name: 'AWL RF - JON ARNOLD RF',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 69,
            name: 'Alaska RF',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 70,
            name: 'Alaska RM',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 71,
            name: 'Tetra Images',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 72,
            name: 'Food Collection',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: true,
            editorialInternationalSearch: true,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 73,
            name: 'Blend RM',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 74,
            name: 'Blend RF',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 75,
            name: 'LushPix Value',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 76,
            name: 'Asia Stock',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 77,
            name: 'Health Head',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 78,
            name: 'Boost',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 79,
            name: 'Glow Cuisine',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 80,
            name: 'Colossus',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 81,
            name: 'Heritage Images',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 83,
            name: 'Inpire Stock Delite',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 84,
            name: 'Inpire Stock Deluxe',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 86,
            name: 'Image Broker',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 87,
            name: 'Photononstop RM',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 88,
            name: 'Photononstop RF',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: true,
            editorialInternationalSearch: true,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 89,
            name: 'Westend61',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 90,
            name: 'Image Broker RM',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 91,
            name: 'Design Pics Perspectives',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 92,
            name: 'Design Pics Vantage',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 93,
            name: 'Alamy',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: true,
            editorialInternationalSearch: true,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 94,
            name: 'Ikon',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 95,
            name: 'Micropayment',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 96,
            name: 'Value Line',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 97,
            name: 'Destination',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 98,
            name: 'The Irish',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 99,
            name: 'F1 Online',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 100,
            name: 'Design Pics',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 101,
            name: 'Blue Jean',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 102,
            name: 'Subscription',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 103,
            name: 'Image Republic',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 104,
            name: 'Image Republic',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 105,
            name: 'South India Picture',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 106,
            name: 'Glow 40260',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 107,
            name: 'Glow Artbox',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 108,
            name: 'Glow Wellness',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 109,
            name: 'Arcticphoto',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 110,
            name: 'Pacific Stock',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 111,
            name: 'Pacific Stock',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 112,
            name: 'National Geography',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 113,
            name: 'PhotoAlto ZenShui',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 114,
            name: 'Photoalto Painto',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 115,
            name: 'PhotoAlto RF',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 116,
            name: 'Robert Harding',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: true,
            editorialInternationalSearch: true,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 117,
            name: 'Citizen Stock',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 118,
            name: 'Eyecandy',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 119,
            name: 'Eyecandy',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 120,
            name: 'Cultura RF',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 121,
            name: 'PhotoAlto',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 122,
            name: 'Maskot',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 123,
            name: 'Cubo',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 124,
            name: 'Yay Micro',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 125,
            name: 'PixMac',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 126,
            name: 'Everett',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 127,
            name: 'Photoshot',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 128,
            name: 'IP VR Images',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 129,
            name: 'Food & Drink',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 131,
            name: 'Oredia',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 132,
            name: 'Mary Evans',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: true,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 133,
            name: 'Phanie',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 134,
            name: 'Ingram',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 135,
            name: 'Axiom',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 136,
            name: 'Axiom',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 137,
            name: 'Axiom',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 138,
            name: 'Cultura',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 139,
            name: 'Eye Ubiquitous',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 140,
            name: 'Flower Photos',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 141,
            name: 'Hemis',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 142,
            name: 'Tips',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 143,
            name: 'Tips',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 144,
            name: 'Image Source',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: true,
            editorialInternationalSearch: true,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 145,
            name: 'Johner',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 146,
            name: 'Naturbild',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 147,
            name: 'Etsabild',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 148,
            name: 'Loop',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 149,
            name: 'Johner RF',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 150,
            name: 'Naturbild RF',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 151,
            name: 'Etsabild RF',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 152,
            name: 'IP Cuisines',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 153,
            name: 'fStop',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 154,
            name: 'Universal Images Group',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: true,
            editorialInternationalSearch: true,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 155,
            name: 'View Picture',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 156,
            name: 'Able Images',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 157,
            name: 'Water Rights',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 158,
            name: 'Gulf Images PANORAMA PRODUCTION',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 159,
            name: 'Erickson',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 160,
            name: 'Agefotostock (Pixtal)',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: true,
            editorialInternationalSearch: true,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000',
                '4k': '16000',
                'HD (1080)': '11000',
                SD: '11000',
                Web2: '11000',
                Web: '11000'
            }
        },
        {
            id: 161,
            name: 'Album Online',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: true,
            editorialInternationalSearch: true,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 162,
            name: 'Images Mart',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 163,
            name: 'Goto -Foto',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 164,
            name: 'CAIA',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 165,
            name: 'MB Media',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 166,
            name: 'Goto Foto',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 167,
            name: 'De Agostini Picture Library',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 168,
            name: 'World History Archive',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 169,
            name: 'Imago Stock & People',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 170,
            name: 'Imago Sports',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 171,
            name: 'Radius',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 172,
            name: 'Agefotostock (EASY)',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: true,
            editorialInternationalSearch: true,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000',
                '4k': '16000',
                'HD (1080)': '11000',
                SD: '11000',
                Web2: '11000',
                Web: '11000'
            }
        },
        {
            id: 173,
            name: 'Red Carpet Images',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 174,
            name: 'Danita Delimont',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 175,
            name: 'Space Images',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 176,
            name: 'Space Images RF',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 177,
            name: 'Novarc',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 178,
            name: 'Narrative',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 180,
            name: 'Cultura Indian RM',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 181,
            name: 'Cultura Indian RF',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 182,
            name: 'Image Source Indian',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: true,
            editorialInternationalSearch: true,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 183,
            name: 'FLPA Images',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 184,
            name: 'Nature Picture Library',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 185,
            name: 'Mint Images',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 186,
            name: 'Mint Images',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 187,
            name: 'Majority World',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: true,
            editorialInternationalSearch: true,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 188,
            name: 'Novarc Images',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 189,
            name: 'Picture Alliance',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 191,
            name: 'Interfoto',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 192,
            name: 'Caia',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 193,
            name: 'Press Association',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 194,
            name: 'Fotosearch RM',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 195,
            name: 'Fotosearch Illustration',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 196,
            name: 'Fotosearch RF',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 197,
            name: 'InPix Premium',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: true,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 202,
            name: 'Hoxton',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 211,
            name: 'Pond 5',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: true,
            editorialInternationalSearch: true,
            creativePrice: {
                '4k': '16000',
                'HD (1080)': '11000'
            },
            editorialPrice: {
                '4k': '16000',
                'HD (1080)': '11000'
            }
        },
        {
            id: 14,
            name: 'Stockimagefactory',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: true,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 203,
            name: 'Erickson RF',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 205,
            name: 'IP_GRAY',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: true,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 130,
            name: 'DreamstimeImages',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: true,
            editorialInternationalSearch: true,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 179,
            name: 'Depositphotos',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: true,
            editorialInternationalSearch: true,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000',
                '4K': '13500',
                'HD (1080)': '13500',
                'HD (720)': '5000',
                SD: '4000',
                Web: '3000'
            },
            editorialPrice: {
                '4k': '13500',
                'HD (1080)': '13500',
                'HD (720)': '5000',
                SD: '4000',
                Web: '3000'
            }
        },
        {
            id: 210,
            name: 'ReutersPicture',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: true,
            editorialInternationalSearch: true,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 212,
            name: 'IP Green',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: true,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 213,
            name: 'Zero-04',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: true,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 214,
            name: 'Zero-05',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: true,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 215,
            name: 'IP Yellow',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: true,
            editorialIndianSearch: true,
            creativeInternationalSearch: true,
            editorialInternationalSearch: true,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 216,
            name: 'Kashmir View',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: true,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 217,
            name: 'Kashmir View (LTD)',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: true,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 218,
            name: 'Inpix Premium-IP',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: true,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 219,
            name: 'IP-Slide',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 220,
            name: 'IP-Wild',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: true,
            editorialIndianSearch: true,
            creativeInternationalSearch: true,
            editorialInternationalSearch: true,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 222,
            name: 'IP- Own',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 223,
            name: 'IP- AI',
            hasSubCategory: false,
            parentId: 0,
            creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: true,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 224,
            name: 'Envato',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: true,
            editorialInternationalSearch: true,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },
        {
            id: 225,
            name: 'IP- AI A',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: false,
            editorialIndianSearch: false,
            creativeInternationalSearch: true,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000'
            }
        },


        {
            id: 228,
            name: 'IP - Motion Creative',
            hasSubCategory: false,
            parentId: 0,
            creativeIndianSearch: true,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000',
                '4K': '15000',
                'HD (1080)': '15000',
                'HD (720)': '5000',
                SD: '5000',
                Web: '5000'
            }
        },
        {
            id: 229,
            name: 'IP - Motion Editorial',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: true,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000',
                '4K': '15000',
                'HD (1080)': '15000',
                'HD (720)': '5000',
                SD: '5000',
                Web: '5000'
            }
        },
        {
            id: 230,
            name: 'INT - Motion Creative',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: true,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000',
                '4K': '15000',
                'HD (1080)': '15000',
                'HD (720)': '5000',
                SD: '5000',
                Web: '5000'
            }
        },
        {
            id: 231,
            name: 'INT - Motion Editorial',
            hasSubCategory: false,
            parentId: 0, creativeIndianSearch: true,
            editorialIndianSearch: false,
            creativeInternationalSearch: false,
            editorialInternationalSearch: false,
            creativePrice: {
                ExtraSmall: '3200',
                Small: '4000',
                Medium: '10000',
                Large: '7000',
                'Extra Large': '21000',
                'Extra Larger': '32000',
                Vector: '21000',
                '4K': '15000',
                'HD (1080)': '15000',
                'HD (720)': '5000',
                SD: '5000',
                Web: '5000'
            }
        }
    ],

    usage: [{
        creative: [
            {
                id: 'all_media',
                slug: 'allMedia',
                name: 'All Media'
            },
            {
                id: 'digital_media',
                slug: 'digitalMedia',
                name: 'Digital Media'
            }
        ],
        editorial: [
            {
                id: 'all_media',
                slug: 'allMedia',
                name: 'All Media'
            },
            {
                id: 'digital_media',
                slug: 'digitalMedia',
                name: 'Digital Media'
            }
        ],
        'creative-videos': [
            {
                id: 'all_media',
                slug: 'allMedia',
                name: 'All Media'
            },
            {
                id: 'digital_media',
                slug: 'digitalMedia',
                name: 'Digital Media'
            }
        ],
        'editorial-videos': [
            {
                id: 'all_media',
                slug: 'allMedia',
                name: 'All Media'
            },
            {
                id: 'digital_media',
                slug: 'digitalMedia',
                name: 'Digital Media'
            }
        ],
    }]
};
